import React, { useEffect } from 'react';

import type {
  ContentfulComponentDefinition,
} from '#contentful/ContentfulComponentDefinition';

export type CrmFormDefinition = CrmFormProps
& ContentfulComponentDefinition
& {
  scriptCode?: {
    text: string,
  },
  internal: {
    type: 'ContentfulComponentCrmForm',
  },
};

type CrmFormProps = {
  content: CrmFormDefinition,
};

const CrmForm = ({
  content,
}: CrmFormProps) => {
  const { scriptCode } = content;
  useEffect(() => {
    const container = document.getElementById('crm-form');
    if (!container || !scriptCode) {
      return undefined;
    }

    const loadForm = async () => {
      const tempContainer = document.createElement('div');
      tempContainer.innerHTML = scriptCode.text;

      const targetDiv = tempContainer.querySelector('div');
      const scriptTag = tempContainer.querySelector('script');

      if (!targetDiv || !scriptTag) {
        container.innerHTML = '<p style="color:red;">Fail to load Form</p>';
        return;
      }

      const formApiUrl = targetDiv.getAttribute('data-form-api-url');
      const readableEventId = targetDiv.getAttribute('data-readable-event-id');
      const scriptSrc = scriptTag.getAttribute('src');

      if (!formApiUrl || !readableEventId || !scriptSrc) {
        container.innerHTML = '<p style="color:red;">Miss Data on Form.</p>';
        return;
      }

      const apiTargetUrl = `${formApiUrl}/event/${readableEventId}/renderformhtml`;

      try {
        const res = await fetch(`/.netlify/functions/renderFormHtml?targetUrl=${encodeURIComponent(apiTargetUrl)}`);
        const html = await res.text();

        container.innerHTML = html;

        if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
          const script = document.createElement('script');
          script.src = scriptSrc;
          script.async = true;
          document.body.appendChild(script);
        }
      } catch (err) {
        container.innerHTML = '<p style="color:red;">Fail to load Form</p>';
      }
    };

    loadForm();

    return () => {
      container.innerHTML = '';
    };
  }, [scriptCode]);

  return (
    <div id="crm-form" className="flex-1" />
  );
};

export default CrmForm;
